import type * as React from 'react';

import { useMetaConfig } from '@xing-com/hub';
import type { ConfigForResolvers } from '@xing-com/meta-renderer';
import { MetaRenderer } from '@xing-com/meta-renderer';
import { commonMetaRendererResolvers } from '@xing-com/platform-layout-common-meta-renderer-resolvers';
import { Me } from '@xing-com/platform-layout-me';

import { MeMenuItem } from './me-menu-item';
export type MeMenuNavigationConfig = ConfigForResolvers<typeof resolvers>;

const resolvers = {
  ...commonMetaRendererResolvers,
  MeMenuItem,
  Me,
};

export const MeMenuList: React.FC = () => {
  const { data } = useMetaConfig();
  const { meMenuNavigation } = data?.navigation ?? {
    meMenuNavigation: [],
  };

  return <MetaRenderer config={meMenuNavigation} resolvers={resolvers} />;
};
